import { reactive } from "@vue/composition-api";
import { UserState } from "./types";

export default function stateFactory(): UserState {
    const state: UserState = {
        user: null
    }
    return reactive(state);
}